import React, { useEffect, useState } from "react";
import { Button, Form, Image, Modal, Nav, Table } from "react-bootstrap";
import {
  MdAddCircleOutline,
  MdDelete,
  MdDeleteOutline,
  MdOutlineEdit,
  MdOutlineInfo,
} from "react-icons/md";
import { HiOutlinePuzzle } from "react-icons/hi";

import { BiImageAdd } from "react-icons/bi";
import { AiOutlineStar } from "react-icons/ai";
import { VscFileBinary } from "react-icons/vsc";
import { MdCategory } from "react-icons/md";

import { useDispatch, useSelector } from "react-redux";
import { apiDeleteSpace, apiGetSpaces, apiSaveSpace, apiUpdateSpace } from "../../../api/ApiSpace";
import { apiGetUsages } from "../../../api/ApiUsage";

import { useTranslation } from "react-i18next";
import { usagesSalles } from "../../../constants/usagesSalles";
import { usagesDigital } from "../../../constants/usagesDigital";
import ModalCropImage from "../../layout/ModalCropImage";

import { forceRefreshData } from "../../../redux/ReduxRefresh";

const ModalSpaces = (props) => {
  const { t } = useTranslation();
  const { id, show, handleClose, editModeForceSpace } = props;
  const dispatch = useDispatch();
  const initialState = {
    nom: "",
    email: "",
    emailResponsable: "",
    mainUse: "",
    secondaryUses: [],
    mainUseDigital: "",
    secondaryUsesDigital: [],
    procedure: "",
    localisation: id,
    zone: "",
    capacite: 0,
    cardPic: "",
    agencements: [],
    usages: [],
  };
  const [state, setState] = useState(initialState);
  const [tabKey, setTabKey] = useState("informations");
  const [spaces, setSpaces] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [croppedImage, setCroppedImage] = useState("");
  const [croppedImageAgencement, setCroppedImageAgencement] = useState("");
  const [image, setImage] = useState("");
  const [photosAgencement, setPhotosAgencement] = useState([]);
  const [imageAgencement, setImageAgencement] = useState("");
  const [showModalCrop, setShowModalCrop] = useState(false);
  const [showModalAgencementCrop, setShowModalAgencementCrop] = useState(false);
  const [usages, setUsages] = useState([]);

  const uses = usagesSalles;
  const usesDigital = usagesDigital;

  useEffect(() => {
    if (id) {
      setState({ ...state, localisation: id });
      recupData();
      if (editModeForceSpace) handleEditMode(editModeForceSpace);
    }
  }, [id, show]); // eslint-disable-line react-hooks/exhaustive-deps

  const recupData = async () => {
    const res = await apiGetSpaces(ReduxInstance._id, "filter[localisation]=" + id);
    setSpaces(res.data);
    const resUsages = await apiGetUsages(ReduxInstance._id);
    setUsages(resUsages.data);
  };

  const handleEditMode = (space) => {
    setTabKey("informations");
    if (space) {
      setState(space);
    }
    setEditMode(true);
  };

  const handleCloseEditMode = () => {
    setState(initialState);
    setCroppedImage("");
    setEditMode(false);
  };

  const submitData = async () => {
    const myForm = new FormData();

    Object.keys(state).forEach((key) => {
      if (Array.isArray(state[key])) {
        state[key].forEach((element) => {
          myForm.append(key + "[]", element);
        });
      } else {
        myForm.append(key, state[key]);
      }
    });

    if (image) {
      myForm.append("image", croppedImage);
    }

    if (photosAgencement) {
      photosAgencement.forEach((element, index) => {
        myForm.append("agencements", element);
      });
    }

    if (state._id) {
      const resUpdate = await apiUpdateSpace(state._id, myForm);
      if (resUpdate) {
        if (editModeForceSpace) {
          handleClose();
          dispatch(forceRefreshData());
        } else {
          setState(initialState);
          setCroppedImage("");
          setCroppedImageAgencement("");
          setPhotosAgencement([]);
          setImageAgencement("");
          setEditMode(false);
          recupData();
        }
      } else {
        console.log("error");
      }
    } else {
      const resSave = await apiSaveSpace(ReduxInstance._id, myForm);
      if (resSave) {
        setState(initialState);
        setCroppedImage("");
        setCroppedImageAgencement("");
        setPhotosAgencement([]);
        setImageAgencement("");
        setEditMode(false);
        recupData();
      } else {
        console.log("error");
      }
    }
  };

  const addRemoveUsage = async (use) => {
    let uses = state.secondaryUses;

    if (uses.includes(use)) {
      uses = uses.filter((item) => item !== use);
    } else {
      uses.push(use);
    }
    setState({ ...state, secondaryUses: uses });
  };

  const addRemoveUsageSalle = async (use) => {
    let usesSalles = state.usages;
    if (usesSalles.includes(use)) {
      usesSalles = usesSalles.filter((item) => item !== use);
    } else {
      usesSalles.push(use);
    }
    setState({ ...state, usages: usesSalles });
  };

  const addRemoveUsageDigital = async (use) => {
    let uses = state.secondaryUsesDigital;

    if (uses.includes(use)) {
      uses = uses.filter((item) => item !== use);
    } else {
      uses.push(use);
    }
    setState({ ...state, secondaryUsesDigital: uses });
  };

  const deleteSpace = async (idSpace) => {
    const res = await apiDeleteSpace(idSpace);
    if (res) {
      setState(initialState);
      setDeleteMode(false);
      recupData();
    } else {
      console.log("error");
    }
  };

  const handleDeleteMode = (space) => {
    if (space) {
      setState(space);
    }
    setDeleteMode(true);
  };

  const handleCloseDeleteMode = () => {
    setState(initialState);
    setDeleteMode(false);
  };

  const onSelectedFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImage(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setShowModalCrop(true);
    }
  };

  const onSelectedImageAgencement = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImageAgencement(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setShowModalAgencementCrop(true);
    }
  };

  const handleCloseCrop = () => {
    setShowModalCrop(false);
  };

  const handleCloseAgencementCrop = () => {
    setShowModalAgencementCrop(false);
  };

  const emptyImage = () => {
    setImage("");
    setCroppedImage("");
    setState({ ...state, cardPic: "" });
    const inputFile = document.getElementById("formBasicImage");
    if (inputFile) {
      inputFile.value = "";
    }
  };

  const emptyImageAgencement = () => {
    setImageAgencement("");
  };

  const emptyPhotoAgencement = (index) => {
    let photosAgencementCopy = [...photosAgencement];
    photosAgencementCopy.splice(index, 1);
    setPhotosAgencement(photosAgencementCopy);
  };

  const emptyPhotoAgencementExistante = (index) => {
    let photosAgencementExistanteCopy = [...state.agencements];
    photosAgencementExistanteCopy.splice(index, 1);
    setState({ ...state, agencements: photosAgencementExistanteCopy });
  };

  useEffect(() => {
    if (croppedImageAgencement) {
      let photosAgencementCopy = [...photosAgencement];
      photosAgencementCopy.push(croppedImageAgencement);
      setPhotosAgencement(photosAgencementCopy);
      setCroppedImageAgencement("");
      setImageAgencement("");
    }
  }, [croppedImageAgencement]); // eslint-disable-line react-hooks/exhaustive-deps

  const hiddenFileInput = React.useRef(null);
  const handleClickHiddenFileInput = (event) => {
    hiddenFileInput.current.click();
  };

  return (
    <Modal
      size="lg"
      show={show}
      onHide={() => {
        handleClose();
        setEditMode(false);
      }}
      className="componentRoomAdmin"
    >
      <Modal.Header closeButton>
        <Modal.Title>{t("admin.PageAdminLocalisations.modalEspacesTitre")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {editMode ? (
          <>
            <Nav
              variant="tabs"
              activeKey={tabKey}
              onSelect={(selectedKey) => {
                setTabKey(selectedKey);
              }}
            >
              <Nav.Item>
                <Nav.Link eventKey="informations">
                  <MdOutlineInfo />
                  {t("admin.PageAdminLocalisations.menuNav1")}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="usages">
                  <MdCategory /> {t("admin.PageAdminLocalisations.menuNav5")}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="utilisationPrincipale">
                  <AiOutlineStar /> {t("admin.PageAdminLocalisations.menuNav3")}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="utilisationDigitale">
                  <VscFileBinary /> {t("admin.PageAdminLocalisations.menuNav4")}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="agencements">
                  <HiOutlinePuzzle /> {t("admin.PageAdminLocalisations.menuNav2")}
                </Nav.Link>
              </Nav.Item>
            </Nav>
            <Form>
              {tabKey === "agencements" && (
                <div className="d-flex mt-2 flex-wrap align-items-center">
                  <BiImageAdd
                    size="
                    3em"
                    onClick={handleClickHiddenFileInput}
                    className=""
                    role="button"
                  />
                  <Form.Control
                    type="file"
                    accept="image/*"
                    onChange={onSelectedImageAgencement}
                    ref={hiddenFileInput}
                    style={{ display: "none" }}
                  />
                  {state.agencements && (
                    <>
                      {state.agencements.map((photoName, index) => (
                        <div
                          key={"photoAgencementExistante_" + index}
                          className="text-center border  m-1 p-1"
                        >
                          <Image
                            width={300}
                            height={169}
                            src={process.env.REACT_APP_URL_EXPRESS + "images/space/" + photoName}
                          />
                          <br />
                          <span role="button" onClick={() => emptyPhotoAgencementExistante(index)}>
                            <MdDelete size="1.5em" />
                          </span>
                        </div>
                      ))}
                    </>
                  )}
                  {photosAgencement && (
                    <>
                      {photosAgencement.map((photo, index) => (
                        <div
                          key={"photoAgencement_" + index}
                          className="text-center border m-1 p-1"
                        >
                          <Image src={URL.createObjectURL(photo)} width={300} height={169} /> <br />
                          <span role="button" onClick={() => emptyPhotoAgencement(index)}>
                            <MdDelete size="1.5em" />
                          </span>
                        </div>
                      ))}
                    </>
                  )}
                  <ModalCropImage
                    show={showModalAgencementCrop}
                    image={imageAgencement}
                    resetImage={emptyImageAgencement}
                    handleClose={handleCloseAgencementCrop}
                    setImageCropped={setCroppedImageAgencement}
                    xRatio={600}
                    yRatio={338}
                  />
                </div>
              )}

              {tabKey === "informations" && (
                <>
                  {croppedImage ? (
                    <div>
                      <div className="mt-2">{t("commun.form.label.image")}</div>
                      <Image src={URL.createObjectURL(croppedImage)} width={300} height={169} />
                      <span role="button" onClick={() => emptyImage()}>
                        <MdDelete size="1.5em" />
                      </span>
                    </div>
                  ) : state.cardPic ? (
                    <div>
                      <div className="mt-2">{t("commun.form.label.image")}</div>
                      <Image
                        width={300}
                        src={process.env.REACT_APP_URL_EXPRESS + "images/space/" + state.cardPic}
                      />
                      <span role="button" onClick={() => emptyImage()}>
                        <MdDelete size="1.5em" />
                      </span>
                    </div>
                  ) : (
                    <div>
                      <label className="mt-2">{t("commun.form.label.image")}</label>
                      <Form.Control type="file" accept="image/*" onChange={onSelectedFile} />
                    </div>
                  )}
                  <ModalCropImage
                    show={showModalCrop}
                    image={image}
                    handleClose={handleCloseCrop}
                    resetImage={emptyImage}
                    setImageCropped={setCroppedImage}
                    xRatio={600}
                    yRatio={338}
                  />
                  <label className="mt-2">{t("commun.form.label.intitule1")}</label>
                  <Form.Control
                    type="text"
                    name="nom"
                    placeholder={t("commun.form.placeholder.placeholder1")}
                    value={state.nom}
                    onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
                  />
                  <label className="mt-2">{t("commun.form.label.email")}</label>
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder={t("commun.form.placeholder.placeholderEmailRegister")}
                    value={state.email}
                    onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
                  />
                  <label className="mt-2">{t("commun.form.label.emailResponsable")}</label>
                  <Form.Control
                    type="text"
                    name="emailResponsable"
                    placeholder={t("commun.form.placeholder.placeholderEmailRegister")}
                    value={state.emailResponsable}
                    onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
                  />
                  <label className="mt-2">{t("commun.form.label.zone")}</label>
                  <Form.Control
                    type="text"
                    name="zone"
                    placeholder={t("commun.form.placeholder.zone")}
                    value={state.zone}
                    onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
                  />
                  <label className="mt-2">{t("commun.form.label.capacite")}</label>
                  <Form.Control
                    type="number"
                    name="capacite"
                    min="0"
                    max="9999"
                    value={state.capacite ? state.capacite : 0}
                    onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
                  />

                  <label className="mt-2">{t("commun.form.label.intitule14")}</label>
                  <Form.Control
                    as="textarea"
                    type="text"
                    name="procedure"
                    placeholder={t("commun.form.placeholder.placeholder7")}
                    style={{ height: "200px" }}
                    value={state.procedure}
                    onChange={(e) => setState({ ...state, [e.target.name]: e.target.value })}
                  />
                </>
              )}

              {tabKey === "utilisationPrincipale" && (
                <div className="flex-grow-1 m-1">
                  <label className="mt-2">{t("commun.form.label.intitule12")}</label>
                  <Form.Select
                    value={state.mainUse == null ? "" : state.mainUse}
                    name="mainUse"
                    onChange={(e) =>
                      setState({
                        ...state,
                        [e.target.name]: e.target.value || null,
                      })
                    }
                    aria-label="Default select example"
                  >
                    <option value="">{t("commun.form.placeholder.placeholder6")}</option>
                    {uses.map((use, index) => {
                      return (
                        <option key={"option" + index} value={use.tag}>
                          {t("commun.usagesSalles." + use.tag)}
                        </option>
                      );
                    })}
                  </Form.Select>
                  <br />
                  <label className="mt-2">{t("commun.form.label.intitule13")}</label>{" "}
                  {uses.map((use, index) => {
                    return (
                      <>
                        <Form.Check
                          key={"check_" + index}
                          className="ms-3"
                          role="button"
                          id={"use-" + use.tag}
                          label={t("commun.usagesSalles." + use.tag)}
                          value={use.tag}
                          onChange={(e) => {
                            addRemoveUsage(e.target.value);
                          }}
                          checked={
                            state.secondaryUses && state.secondaryUses.includes(use.tag)
                              ? "checked"
                              : ""
                          }
                        />
                      </>
                    );
                  })}
                </div>
              )}
              {tabKey === "utilisationDigitale" && (
                <div className="flex-grow-1 m-1">
                  <label className="mt-2">{t("commun.form.label.intitule15")}</label>
                  <Form.Select
                    value={state.mainUseDigital == null ? "" : state.mainUseDigital}
                    name="mainUseDigital"
                    onChange={(e) =>
                      setState({
                        ...state,
                        [e.target.name]: e.target.value || null,
                      })
                    }
                    aria-label="Default select example"
                  >
                    <option value="">{t("commun.form.placeholder.placeholder6")}</option>
                    {usesDigital.map((useDigital, index) => {
                      return (
                        <option key={"option" + index} value={useDigital.tag}>
                          {t("commun.usagesDigital." + useDigital.tag)}
                        </option>
                      );
                    })}
                  </Form.Select>
                  <br />
                  <label className="mt-2">{t("commun.form.label.intitule16")}</label>
                  {usesDigital.map((useDigital, index) => {
                    return (
                      <Form.Check
                        key={"check_" + index}
                        className="ms-3"
                        role="button"
                        id={"useDigital-" + useDigital.tag}
                        label={t("commun.usagesDigital." + useDigital.tag)}
                        value={useDigital.tag}
                        onChange={(e) => {
                          addRemoveUsageDigital(e.target.value);
                        }}
                        checked={
                          state.secondaryUsesDigital &&
                          state.secondaryUsesDigital.includes(useDigital.tag)
                            ? "checked"
                            : ""
                        }
                      />
                    );
                  })}
                </div>
              )}

              {tabKey === "usages" && (
                <>
                  {usages.map((usageSalle, index) => (
                    <Form.Check
                      key={"checkUsagesSalle_" + index}
                      className="ms-3"
                      role="button"
                      id={"usages-" + index}
                      label={usageSalle.nom}
                      value={usageSalle._id}
                      onChange={(e) => {
                        addRemoveUsageSalle(e.target.value);
                      }}
                      checked={
                        state.usages && state.usages.includes(usageSalle._id) ? "checked" : ""
                      }
                    ></Form.Check>
                  ))}
                </>
              )}

              <div style={{ marginTop: 50, marginRight: 8 }}>
                {!editModeForceSpace && (
                  <Button
                    style={{ marginRight: 8 }}
                    variant="primary"
                    onClick={handleCloseEditMode}
                  >
                    {t("commun.form.button.retour")}
                  </Button>
                )}
                <Button variant="success" onClick={submitData}>
                  {state._id ? t("commun.form.button.modifier") : t("commun.form.button.ajouter")}
                </Button>
              </div>
            </Form>
          </>
        ) : deleteMode ? (
          <div style={{ textAlign: "center" }}>
            <div>
              {t("admin.PageAdminLocalisations.modalEspaceDeleteText")} <strong>{state.nom}</strong>
            </div>
            <div style={{ marginTop: 10, marginRight: 8 }}>
              <Button style={{ marginRight: 8 }} variant="primary" onClick={handleCloseDeleteMode}>
                {t("commun.form.button.annuler")}
              </Button>
              <Button variant="success" onClick={() => deleteSpace(state._id)}>
                {t("commun.form.button.confirmer")}
              </Button>
            </div>
          </div>
        ) : (
          <>
            <span role="button" onClick={() => handleEditMode()}>
              <MdAddCircleOutline size="1.5em" />
              {t("admin.PageAdminLocalisations.modalEspacesButtonAjouter")}
            </span>
            <Table striped bordered hover className="stickyTable mt-2">
              <thead>
                <tr>
                  <th>{t("admin.PageAdminLocalisations.modalEspacesTitreColonne1")}</th>
                  {/* <th> {t("admin.PageAdminLocalisations.modalEspacesTitreColonne2")}</th>
                  <th> {t("admin.PageAdminLocalisations.modalEspacesTitreColonne3")}</th> */}
                  <th className="text-center">
                    {t("admin.PageAdminLocalisations.modalEspacesTitreColonne4")}
                  </th>
                  <th className="text-center">
                    {t("admin.PageAdminLocalisations.modalEspacesTitreColonne5")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {spaces
                  .sort((a, b) =>
                    a.nom.toLowerCase() > b.nom.toLowerCase()
                      ? 1
                      : b.nom.toLowerCase() > a.nom.toLowerCase()
                      ? -1
                      : 0
                  )
                  .map((space) => (
                    <tr key={space._id}>
                      <td>{space.nom}</td>
                      {/* <td>
                        {space.mainUse != "null" && space.mainUse
                          ? t("commun.usagesSalles." + space.mainUse)
                          : "n/a"}
                        <hr />
                        {space.mainUseDigital != "null" && space.mainUseDigital
                          ? t("commun.usagesDigital." + space.mainUseDigital)
                          : "n/a"}
                      </td>
                      <td>
                        {space.secondaryUses.sort().map((use, index) => {
                          return (
                            <div key={"secondaryUse" + index}>
                              - {t("commun.usagesSalles." + use)}
                            </div>
                          );
                        })}
                        <hr />
                        {space.secondaryUsesDigital.sort().map((use, index) => {
                          return (
                            <div key={"secondaryUseDigital" + index}>
                              - {t("commun.usagesDigital." + use)}
                            </div>
                          );
                        })}
                      </td> */}
                      <td className="text-center">
                        <MdOutlineEdit
                          size="1.5em"
                          role="button"
                          onClick={() => handleEditMode(space)}
                        />
                      </td>
                      <td className="text-center">
                        <MdDeleteOutline
                          size="1.5em"
                          role="button"
                          onClick={() => handleDeleteMode(space)}
                        />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default ModalSpaces;
